import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { ok } from "@nju/result";
import { IParams } from "./types";
import { serverResponse } from "./validators";

export async function fetchOrders({
  statusFilters,
  paymentFilters,
  offerTypeFilters,
  cancellationReasonFilters,
  sort,
  page,
  perPage,
}: IParams) {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/orders`,
    {
      headers: {
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
        version: "3",
      },

      scope: "sales",
      validator: serverResponse,
      searchParams: {
        ...(statusFilters && { status: statusFilters }),
        ...(paymentFilters && {
          paymentStatus: paymentFilters,
        }),
        ...(offerTypeFilters && {
          subCategory: offerTypeFilters,
        }),
        ...(cancellationReasonFilters && {
          cancellationReason: cancellationReasonFilters,
        }),
        page,
        perPage,
        ...(sort && { sort }),
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return ok({
    orders: result.value.orders,
    page: result.value.page,
    perPage: result.value.perPage,
    total: result.value.total,
  });
}
